var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPin2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.566 9.939a.81.81 0 0 0-1.147 1.146l2.171 2.17-2.48 3.72a.66.66 0 0 0 .915.914l3.72-2.48 2.17 2.172a.81.81 0 0 0 1.146-1.146l-.573-.574 3.404-3.404a3.783 3.783 0 0 0-5.35-5.35L8.14 10.513z"
})));
export default SvgPin2;